// extracted by mini-css-extract-plugin
export default {"noPermissions":"NoPermissions_noPermissions__KNfrK","top":"NoPermissions_top__ghaPB"};